import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email:null
}

export const user_slice = createSlice({
  name: "user",
  initialState:initialState,
  reducers: {
    emailStorage(state, action) {
        // console.log('action is',action)
        // console.log('state changes',state.email)
        state.email= action.payload
      }
  }
});

export const { emailStorage } = user_slice.actions;
